<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.INVENTORY' | translate }}</h1>
                <app-form-group class="actionbuttons">
                    <button [disabled]="!hasIncludeFlags()" (click)="changeResponsible()" type="button">
                        {{ 'BUTTONS.CHANGE_AGREEMENT_RESPONSIBLE' | translate }}
                    </button>
                    <button [disabled]="!hasIncludeFlags()" (click)="confirmRemoveAgreements($event)" type="button">
                        {{ 'BUTTONS.REMOVE' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> delete </span>
                    </button>
                    <button
                        *appHasPermissions="[permissions.WriteAgreement]"
                        (click)="goToCreateNewAgreement()"
                        class="primary"
                        type="button"
                    >
                        {{ 'BUTTONS.CREATE_INVENTORY' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </app-form-group>
            </app-form-row>

            <div class="action-box">
                <div class="search-box">
                    <app-search-input formControlName="searchPhrase" />

                    <div class="actions">
                        <ng-container *ngIf="numOfInventories">
                            <div class="agreement-summary">
                                <span
                                    [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.NUM_OF_INVENTORIES' | translate"
                                    class="material-symbols-rounded leading"
                                    aria-hidden="true"
                                >
                                    inventory_2
                                </span>
                                <span>{{ numOfInventories }}</span>
                            </div>
                        </ng-container>
                        <button
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.SHOW_HIDE' | translate"
                            (click)="showHeader = !showHeader"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true" *ngIf="showHeader">
                                visibility
                            </span>
                            <span class="material-symbols-rounded leading" aria-hidden="true" *ngIf="!showHeader">
                                visibility_off
                            </span>
                            <span>
                                {{ 'BUTTONS.HEADERS' | translate }}
                            </span>
                        </button>
                        <button
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.SHOW_HIDE' | translate"
                            [tooltipPosition]="'left'"
                            (click)="showFilter = !showFilter"
                            [ngClass]="{ activated: !showFilter }"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true"> filter_list </span>
                            <span>{{ 'BUTTONS.FILTER_TOGGLE_BUTTON' | translate }}</span>
                        </button>

                        <button *ngIf="!isFilterEmpty" (click)="clearFilter()" class="text" type="button">
                            <span>{{ 'BUTTONS.FILTER_CLEAR_FILTER' | translate }}</span>
                            <span class="material-symbols-rounded trailing" aria-hidden="true"> clear </span>
                        </button>
                    </div>
                </div>
                <div class="filter-box">
                    <app-form-group>
                        <app-agreement-filter
                            [tableType]="tableType"
                            [config]="filterConfig"
                            [visible]="showFilter"
                            (filterChange)="onFilterChange($event)"
                            (isFilterEmptyChanged)="isFilterEmpty = $event"
                        ></app-agreement-filter>
                    </app-form-group>
                </div>
            </div>
        </app-form-section>
    </form>
</app-filter-container>
<div>
    <app-table [loading]="loading" [clickable]="true">
        <tr thead [hidden]="!showHeader" class="distinct">
            <app-table-header
                [align]="align.Center"
                [width]="1"
                *appHasPermissions="[permissions.WriteAgreement]"
                [checkbox]="true"
                (checkedChanged)="onCheckedAllChange($event)"
            />
            <app-table-header
                [isActive]="sortKey === 'typeOfInventory'"
                [defaultAscending]="sortKey === 'typeOfInventory' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.TYPE_OF_INVENTORY' | translate"
                (sortChanged)="onSortChange('typeOfInventory', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'manufacturer'"
                [defaultAscending]="sortKey === 'manufacturer' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.MANUFACTURER' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.MODEL' | translate"
                (sortChanged)="onSortChange('manufacturer', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'user'"
                [defaultAscending]="sortKey === 'user' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.USER' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.LOCATION' | translate"
                (sortChanged)="onSortChange('user', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'inventoryNumber'"
                [defaultAscending]="sortKey === 'inventoryNumber' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.INVENTORY_NUMBER' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.SERIAL_NUMBER' | translate"
                (sortChanged)="onSortChange('inventoryNumber', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'created'"
                [defaultAscending]="sortKey === 'created' && sortAscending"
                [sort]="true"
                [align]="align.Right"
                [width]="20"
                [text]="'COLUMNS.CREATED' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.COLUMNS.VALID_FROM_TO' | translate"
                (sortChanged)="onSortChange('created', $event)"
            />
        </tr>
        <ng-container tbody>
            <tr *ngFor="let item of agreements$ | async" title="{{ getTitle(item) }}">
                <td class="action" *appHasPermissions="[permissions.WriteAgreement]">
                    <app-checkbox
                        *ngIf="hasWritePermission(item)"
                        [ngModel]="includeFlags[item.id] || false"
                        (ngModelChange)="onIncludeToggle(item.id, $event)"
                    />
                </td>
                <td (click)="navigateToAgreement(item.id)">{{ item.typeOfInventory }}<br /></td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.manufacturer }}<br />
                    <span class="secondary">{{ item.model }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.user }}<br />
                    <span class="secondary">{{ item.location }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.inventoryNumber }}<br />
                    <span class="secondary"> {{ item.serialNumber }}</span>
                </td>

                <td (click)="navigateToAgreement(item.id)" class="date">
                    <span class="right">
                        {{ item.created | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
                    </span>
                    <br />
                    <span class="secondary">
                        {{ item.validFrom | dateTime: 'yyyy-MM-dd' | replaceEmptyString }} -
                        {{ item.validTo | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
                    </span>
                </td>
            </tr>
        </ng-container>
    </app-table>
</div>
